import { render } from "./EventviewBetGroupAdditional.vue?vue&type=template&id=dd3b9ef4"
import script from "./EventviewBetGroupAdditional.vue?vue&type=script&lang=js"
export * from "./EventviewBetGroupAdditional.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__